export const P: bigint = BigInt("21888242871839275222246405745257275088548364400416034343698204186575808495617");

export const MAX_ALLOWANCE = BigInt('115792089237316195423570985008687907853269984665640564039457584007913129639935'); // 2**256 - 1
